import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {MessageThreadSummary} from '@/api/dto/message';

type MessageState = {
  popoverOpen: boolean;
  setPopoverOpen(val: boolean): void;
  isApiLoading: boolean;
  setApiLoading(val: boolean): void;
  messageThreadSummaries: MessageThreadSummary[];
  setMessageThreadSummaries(val: MessageThreadSummary[]): void;
  totalMessages: number;
  setTotalMessages(val: number): void;
  totalUnreadMessages: number;
  setTotalUnreadMessages(val: number): void;
}

export const useMessageStore = create<MessageState>()(
  devtools(
    (set) => ({
      popoverOpen: false,
      setPopoverOpen: (val) => set({ popoverOpen: val }),
      isApiLoading: false,
      setApiLoading: (val) => set({ isApiLoading: val }),
      messageThreadSummaries: [],
      setMessageThreadSummaries: (val) => set({ messageThreadSummaries: val }),
      totalMessages: 0,
      setTotalMessages: (val) => set({ totalMessages: val }),
      totalUnreadMessages: 0,
      setTotalUnreadMessages: (val) => set({ totalUnreadMessages: val }),
    }),
    {
      name: 'messageStore',
      enabled: ['local', 'dev', 'qa'].includes(process.env.REACT_APP_ENV || 'prod'),
    },
  ),
);
